import React from "react";
import SelectedCheckIcon from "../../../../Common/SelectedCheckIcon";

const ListItem = ({ title, subTitle, selectedItem, itemId, logo }) => {
  return (
    <div
      className={`flex items-center justify-start relative border mt-4 w-full px-4 py-3 rounded-3xl cursor-pointer ${
        selectedItem.id === itemId
          ? "account-list-item-selected"
          : "account-list-item-default"
      }`}
    >
      {selectedItem.id === itemId && (
        <SelectedCheckIcon />
      )}

      {logo ? (
        <img src={logo} alt="logo" className="w-10 h-10 rounded-full mr-3" />
      ) : (
        <img
          className="w-10 h-10 mr-3 rounded-full"
          src={require("../../../../../assets/images/profile.png")}
          alt="profile_picture"
        />
      )}
      <div className="flex-col justify-start items-start gap-1 inline-flex">
        <h2 className="account-list-item-title text-sm font-medium leading-tight tracking-tight">
          {title}
        </h2>
        <h3 className="account-list-item-sub-title text-sm font-normal leading-tight tracking-tight">
          {subTitle}
        </h3>
      </div>
    </div>
  );
};

export default ListItem;
